import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { LifecycleStageTender } from '@/constants/lifecycleStages';

interface Args {
  projectId: string;
  stage: LifecycleStageTender | null;
}

const isRlsError = (err: any): boolean => {
  const msg = (err?.message || '').toLowerCase();
  return (
    err?.code === '42501' ||
    msg.includes('row-level security') ||
    msg.includes('permission denied') ||
    msg.includes('insufficient_privilege')
  );
};

export const useUpdateLifecycleStageTender = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ projectId, stage }: Args) => {
      const { error } = await supabase
        .from('projects')
        .update({ lifecycle_stage_tender: stage } as any)
        .eq('id', projectId);
      if (error) throw error;
    },
    onSuccess: (_d, { projectId }) => {
      qc.invalidateQueries({ queryKey: ['project', projectId] });
      qc.invalidateQueries({ queryKey: ['project-edit', projectId] });
      qc.invalidateQueries({ queryKey: ['project-detail', projectId] });
      qc.invalidateQueries({
        queryKey: ['projects-optimized-v2'],
        exact: false,
        refetchType: 'active',
      });
      qc.invalidateQueries({ queryKey: ['projects', 'status-stats'], exact: false });
      toast.success('Đã cập nhật Tender Lifecycle Stage');
    },
    onError: (err: any) => {
      if (isRlsError(err)) toast.error('Bạn không có quyền sửa Tender Lifecycle Stage');
      else toast.error(err?.message || 'Cập nhật Tender Lifecycle Stage thất bại');
    },
  });
};
